import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion, MotionConfig } from 'framer-motion';
import './App.css';
import Home from './pages/Home';
import TalentRosterPage from './pages/TalentRosterPage';
import CaseStudyPage from './pages/CaseStudyPage';
import ThankYouPage from './pages/ThankYouPage';
import NotFoundPage from './pages/NotFoundPage';
import LegalPage from './pages/LegalPage';
import AdminDashboard from './components/AdminDashboard';
import ScrollProgress from './components/ui/ScrollProgress';
import CursorGlow from './components/ui/CursorGlow';
import { privacy, terms } from './data/legalContent';

// Opacity-only page transition — safe for the fixed navbar (a transform/filter
// on an ancestor would break position: fixed).
const pageTransition = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={location.pathname}
        variants={pageTransition}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
      >
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/talent-roster" element={<TalentRosterPage />} />
          <Route path="/work/:slug" element={<CaseStudyPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/privacy" element={<LegalPage doc={privacy} />} />
          <Route path="/terms" element={<LegalPage doc={terms} />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
}

function App() {
  // reducedMotion="user" makes ALL framer-motion animations respect the
  // prefers-reduced-motion OS setting (CSS media queries can't reach JS animation).
  return (
    <MotionConfig reducedMotion="user">
      <Router>
        <a href="#main-content" className="skip-link">
          Skip to main content
        </a>
        <ScrollProgress />
        <CursorGlow />
        <AnimatedRoutes />
      </Router>
    </MotionConfig>
  );
}

export default App;
